import { createReducer } from '@reduxjs/toolkit'

import { CustomerAgreement } from 'types/GlobalCustomerAgreement'

import * as actions from '../../../actions/internal/CustomerAgreements/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

export interface ICustomerAgreementsReducerType {
  [customerId: string]: CustomerAgreement[]
}

const INITIAL_STATE: ICustomerAgreementsReducerType = {}

const CustomersAndLicensesReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.createSuccess, (state, action) => {
      const { payload } = action

      if (!state[payload.customer_id]) {
        state[payload.customer_id] = []
      }

      state[payload.customer_id].push(payload)
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state[action.payload.customerId] = action.payload.agreements
    })
    .addCase(actions.updateSuccess, (state, action) => {
      const { payload } = action

      // Updated agreement moves to the end, as before.
      state[payload.customer_id] = [
        ...(state[payload.customer_id] ?? []).filter(
          (agreement) => agreement.id !== payload.id
        ),
        payload
      ]
    })
    .addCase(actions.destroySuccess, (state, action) => {
      const { customerId, agreementId } = action.payload

      state[customerId] = (state[customerId] ?? []).filter(
        (agreement) => agreement.id !== agreementId
      )
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default CustomersAndLicensesReducer
